import { MatElementsModule } from './../_modules/mat-elements.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';


import { MbenzFeePaymentRoutingModule } from './mbenz-fee-payment-routing.module';
import { MbenzPaylayoutComponent } from './mbenz-paylayout.component';
import { MbenzPayStudentComponent } from './mbenz-pay-student.component';

import { MatIconModule } from '@angular/material/icon';
import { MbenzCaptureResponseComponent } from './mbenz-capture-response.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({

  imports: [
    CommonModule,
    ReactiveFormsModule,
    MbenzFeePaymentRoutingModule,
    //MatElementsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule
  ],
  declarations: [
    MbenzPaylayoutComponent,
    MbenzPayStudentComponent,
    MbenzCaptureResponseComponent
  ]
})
export class MbenzFeePaymentModule { }
